import {Component, Input} from '@angular/core';
import { Patient } from '../../models/pateint';
import { PatientsApplicationsService } from '../../services/patients-applications.service';

@Component({
  selector: 'app-inr-patient-attachments',
  templateUrl: './inr-patient-attachments.component.html',
  styleUrls: ['./inr-patient-attachments.component.scss']
})
export class InrPatientAttachmentsComponent {
  @Input() patientData!: Patient;

  constructor(private readonly patientService: PatientsApplicationsService) {
  }

  downloadFile(file: any): void {
    this.patientService.show();
    this.patientService.getFile(this.patientData.idNumber, this.patientData.patientApplication.id, file.name, file.type)
      .subscribe((data) => {
        var fileType = ""
        switch (file.type) {
          case "pdf":
            fileType = "application/pdf";
            break;
          case "doc":
            fileType = "application/msword";
            break;
          case "docx":
            fileType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            break;
          case "png":
            fileType = "image/png";
            break;
          case "jpg":
            fileType = "image/jpeg";
            break;
          case "jpeg":
            fileType = "image/jpeg";
            break;
          case "jpeg2":
            fileType = "image/jpeg";
            break;
        }

        const blob = new Blob([data as BlobPart], {
          type: fileType,
        });
        const url = window.URL.createObjectURL(blob);
        this.patientService.hide();
        window.open(url);
      })
  }
}
